<script>
import { esellerMethods, esellerComputed, layoutMethods, productListMethods, productListComputed, exportMethods,erpFixMessages } from "@/state/helpers";
import ellipsize from 'ellipsize';
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

/**
 * Product listing component
 */
export default {
  page: {
    title: "Product Listing",
  },
  components: {
    Multiselect
  },
  data() {
    return {
      createModal: false,
      editModal: false,
      title: "Product Listing",
      folder: "product-images",
      pagination: {
        rows: 10,
        page: 1,
        keyword: '',
        field: 'name',
        brand: '',
        group: '',
        sort: 'id',
        orderDesc: true
      },
      displayValueList: [
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "30", value: 30 },
        { text: "40", value: 40 },
        { text: "50", value: 50 },
        { text: "60", value: 60 },
        { text: "70", value: 70 },
        { text: "80", value: 80 },
        { text: "90", value: 90 },
        { text: "100", value: 100 }
      ],
      lookupParams: {
        keyword: '',
        field: null,
        brand: '',
        group: '',
        status: null,
      },
      searchOptions: [
        { text: 'Search All', value: null },
        { text: 'Product Name', value: 'name' },
        { text: 'Product Description', value: 'description' }
      ],
      statusOptions: [
        { text: 'All', value: null },
        { text: 'Active', value: 1 },
        { text: 'Inactive', value: 0 }
      ],
      fieldsProductListing: [
        {
          key: "productName",
          sortable: true,
        },
        {
          key: "productDescription",
          label: "Description",
          sortable: true,
        },
        {
          key: "productBrandName",
          label: "Brand",
          sortable: true,
        },
        {
          key: "productCategory",
          label: "Category",
          sortable: true,
        },
        {
          key: "totalSold",
          label: "Units Sold",
          tdClass: "text-end",
          sortable: true,
        },
        // {
        //   key: "totalShipped",
        //   label: "Units Shipped",
        //   tdClass: "text-end",
        //   sortable: false,
        // },
        // {
        //   key: "totalCompleted",
        //   label: "Units Completed",
        //   tdClass: "text-end",
        //   sortable: false,
        // },
        {
          key: "productPrice",
          sortable: true,
          tdClass: "text-end",
          thClass: "text-end",
        },
        {
          key: "productStatus",
          label: "Product Status",
          sortable: true,
        },
      ],
      productImage: {
        filename: null,
        type: null,
        base64: null
      },
    };
  },
  computed: {
    ...esellerComputed,
    ...productListComputed,
    ...erpFixMessages,
    productBrand: {
      get() {
        var productBrand = null;
        this.productBrandOptions.forEach((b) => {
          if (b.value == this.lookupParams.brand) {
            productBrand = b;
          }
        });
        return productBrand;
      },
      set(productBrand) {
        if (productBrand) {
          this.lookupParams.brand = productBrand.value;
        } else {
          this.lookupParams = null;
        }
      },
    },
    productGroup: {
      get() {
        var productGroup = null;
        this.productGroupOptions.forEach((g) => {
          if (g.value == this.lookupParams.group) {
            productGroup = g;
          }
        });
        return productGroup;
      },
      set(productGroup) {
        if (productGroup) {
          this.lookupParams.group = productGroup.value;
        } else {
          this.lookupParams.group = null;
        }
      },
    },
    productGroupOptions: {
      get() {
        var options = [{ text: 'All', value: '' }];
        this.productGroups.forEach(group => {
          options.push({ 'text': group.groupName, 'value': group.groupId });
        });
        return options;
      }
    },
    productBrandOptions: {
      get() {
        var brands = [{ text: 'All', value: '' }];
        this.brands.forEach(brand => {
          brands.push({ 'text': brand.brandName, 'value': brand.brandId })
        });
        return brands;
      }
    },
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    ...esellerMethods,
    ...exportMethods,
    async onExport(){
      await this.search();
      if(this.productTotalRows ==0 ){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = Object.assign(
        this.pagination, 
        this.lookupParams, 
        {
          module: 'esupplies_products',
          email: JSON.parse(localStorage.getItem('userData')).email
        }),
          page = params.page,
          rows = params.rows;

      delete params.page;
      delete params.rows;
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      params.page = page
      params.rows = rows
    },
    refresh() {
      this.listESellerProducts();
    },
    async listESellerProducts() {
      await this.listSellerProducts(this.pagination);
    },
    onChangeRows() {
      if (this.productTotalRows !== this.products.length) this.listSellerProducts(this.pagination);
    },
    shorten(text) {
      return ellipsize(text, 50);
    },
    async search() {
      this.pagination.page = 1;
      this.pagination = Object.assign(this.pagination, this.lookupParams);
      await this.listESellerProducts();
    },
    handleSort(ctx) {
      this.pagination.sort = ctx.sortBy;
      this.pagination.orderDesc = ctx.sortDesc;
      this.listESellerProducts();
    },
  },
  mounted() {
    // Product list
    this.listProductGroups({ rows: 99999, sort: 'name', orderDesc: false });
    this.listSellerBrands({ rows: 99999, sort: 'brandName', orderDesc: false });
    this.listESellerProducts();
    this.changeTitle({ title: 'E-Seller Products' });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'E-Seller', to: { name: 'ESeller' } },
        { text: 'Products', to: { name: 'ESeller Product' } }
      ]
    });
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-lg-2">{{ productTotalRows }}</span> Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-8 col-sm-8" style="text-align: right;">
                <div class="mb-lg-3">
                  <b-button variant="primary"  type="button" @click="onExport" class="btn btn-primary h-fit me-2">
                    <i class='bx bx-export bx-fw me-1'></i>Export
                  </b-button>
                  <button class="btn btn-secondary" @click="refresh()">
                    <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                  </button>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->

            <div class="d-flex flex-wrap mt-3 mb-3">
              <div class="me-3">
                <form class="d-flex" @submit.prevent="search()">
                  <b-form-group id="input-group-3" label-for="input-3">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px"
                      id="input-3" v-model="lookupParams.field" :options="searchOptions"></b-form-select>
                  </b-form-group>
                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3" description="Search for keyword">
                    <b-input-group>
                      <b-form-input class="rounded-0" v-model="lookupParams.keyword"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </form>
              </div>
              <div class="me-3 w-250px">
                <b-form-group description="Filter by brand" class="text-align-right">
                  <multiselect v-model="productBrand" :options="productBrandOptions" track-by="value" label="text"
                    select-label="Click to select" deselect-label="Click to remove" placeholder="Select Brand"
                    :allow-empty="false" :preselect-first="true"></multiselect>
                </b-form-group>
              </div>
              <div class="me-3 w-250px">
                <b-form-group description="Filter by category" class="text-align-right">
                  <multiselect v-model="productGroup" :options="productGroupOptions" track-by="value" label="text"
                    select-label="Click to select" deselect-label="Click to remove" placeholder="Select Group"
                    :allow-empty="false" :preselect-first="true"></multiselect>
                </b-form-group>
              </div>
              <div class="me-3">
                <b-form-group description="Filter by status" class="text-align-right">
                  <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                    id="input-3" v-model="lookupParams.status" :options="statusOptions"></b-form-select>
                </b-form-group>
              </div>
              <div class="me-2">
                <b-form-group label="">
                  <b-button variant="primary" type="button" @click="search" class="px-2">
                    <i class='bx bx-search bx-fw'></i>
                    Search
                  </b-button>
                </b-form-group>
              </div>
            </div>

            <!-- table -->
            <template>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table  :items="products" :fields="fieldsProductListing"
                    :no-local-sorting="true" @sort-changed="handleSort" :per-page="pagination.rows">
                    <template #cell(productName)="row">
                      <b-link class="text-primary font-size-14 fw-bold">{{ row.item.productName }}</b-link>
                    </template>

                    <template #cell(productDescription)="row">
                      {{ shorten(row.item.productDescription) }}
                    </template>

                    <template #cell(productPrice)="row">
                      ₱{{ row.item.productPrice.toFixed(2) }}
                    </template>
                    <!-- <template #cell(totalShipped)="row">
                      {{ row.item.totalShipped }}
                    </template>
                    <template #cell(totalCompleted)="row">
                      {{ row.item.totalCompleted }}
                    </template> -->
                  </b-table>
                </div>
              </div>
            </template>
            <div class="row g-0 text-center" v-if="productTotalRows == 0">
              <span>No data to display.</span>
            </div>

            <div class="row g-0 text-center text-sm-start" v-if="productTotalRows != 0 && productTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <label class="d-inline-flex align-items-center">Display: &nbsp;
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none w-5" style="width: 75px"
                        id="display_perpage" v-model="pagination.rows" :options="displayValueList"
                        v-on:change="onChangeRows"></b-form-select>
                    </label>
                  </div>
                  <div class="col">
                    <div class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      ">
                      <!-- pagination -->
                      <b-pagination v-if="productPage.noOfPage > 1 || pagination.rows < productTotalRows" class="pagination-rounded" v-model="pagination.page" @input="listESellerProducts"
                        :total-rows="productTotalRows" :per-page="pagination.rows"></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style>
.m-150px {
  min-width: 150px;
}

.w-300px {
  width: 300px;
}

.w-350px {
  width: 350px;
}

.w-200px {
  width: 200px;
}
.w-250px {
  width: 250px;
}
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid~.invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.text-align-right div{
  text-align: right;
}
.text-align-right div div{
  text-align: left !important;
}
</style>